"use client";

import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Label } from "@/components/ui/label";
import { useEventUpdates } from "@/pages/events/features/notifications/event-updates-context";

export function ArtistSelectionModal() {
  const {
    isArtistModalOpen,
    closeArtistModal,
    selectedArtists,
    artists,
    toggleArtist,
    sendEventUpdates,
  } = useEventUpdates();

  const handleSendLineupNotification = () => {
    if (selectedArtists.length > 0) {
      sendEventUpdates("lineup_added", { artistIds: selectedArtists });
    }
  };

  return (
    <Dialog
      open={isArtistModalOpen}
      onOpenChange={(open) => !open && closeArtistModal()}
    >
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Select Artists to Announce</DialogTitle>
          <DialogDescription>
            Choose which artists from the lineup you want to announce to your
            audience.
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-4 py-4">
          {artists.map((artist) => (
            <div key={artist.id} className="flex items-center space-x-2">
              <Checkbox
                id={artist.id}
                checked={selectedArtists.includes(artist.id)}
                onCheckedChange={() => toggleArtist(artist.id)}
              />
              <Label
                htmlFor={artist.id}
                className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
              >
                {artist.name}
              </Label>
            </div>
          ))}
        </div>

        <DialogFooter className="flex gap-2">
          <Button variant="outline" onClick={closeArtistModal}>
            Cancel
          </Button>
          <Button
            onClick={handleSendLineupNotification}
            disabled={selectedArtists.length === 0}
          >
            Send Announcement ({selectedArtists.length})
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
